// Pure helpers for the "first invoice number" editor. Kept separate from the component
// so the validate/enable logic is unit-testable without rendering. Error codes map to
// <Text> messages in the component. Mirrors the backend rules in
// backend/lib/invoice-start-number.js (kept in sync by hand; two runtimes, no shared import).

const MAX_INVOICE_NUMBER = 2000000000;

export function validateFirstInvoiceNumber(value) {
    const n = Number(value);
    if (!Number.isInteger(n)) {
        return { ok: false, error: 'notInteger' };
    }
    if (n <= 0) {
        return { ok: false, error: 'notPositive' };
    }
    if (n >= MAX_INVOICE_NUMBER) {
        return { ok: false, error: 'tooLarge' };
    }
    return { ok: true, value: n };
}

export function canConfirm({ value, understood } = {}) {
    return validateFirstInvoiceNumber(value).ok === true && understood === true;
}
